// Typescript
interface PartnerArr {
    id: number
    title: string
    description: string
    icon: string
    subHeading?: string
}

const Partners = () => {
    // Constant:
    const partnersArr = [
        {
            id: 0,
            title: 'Knowledge Power',
            description: 'Classroom program for JEE/NEET and Foundation preparations.',
            icon: '/assets/pace-logo.png',
            subHeading: 'Classes 7 to 12'
        },
        {
            id: 1,
            title: 'Technology Partner',
            description: 'Learn through Innovative Gamified Content mapped to your school syllabus for strengthening your concept in Math & Science',
            icon: '/assets/step-app.png',
            subHeading: 'Classes 1 to 12'
        },
        {
            id: 2,
            title: 'Entrepreneurial Partner',
            description: 'A platform to nurture the budding entrepreneurs with vision to produce more job creators.',
            icon: '/assets/iit-delhi.png'
        },
        {
            id: 3,
            title: 'Upskilling Partner',
            description: 'Upskilling platform that offers advanced training programs and professional guidance.',
            icon: '/assets/expertons.png'
        },
    ]
    return <div className='col-[2_/_3] my-[4rem] flex flex-col items-center'>
        <h2 className='text-[30px] md:text-[40px] font-extrabold mb-[40px]'>Our Partners</h2>
        <p className='text-[#7D7D7D] text-[18px] md:text-[20px] text-center'> We take a great responsibility in choosing our partners and make sure together we deliver the best 
            quality results for our students.Here are a few collaborations we have formed to ensure children have 
            a pleasant and easy learning experience. Genius Teachers, Genius Performance, One platform for your every 
            educational need!</p>

        <div className='flex flex-wrap gap-[25px] mt-[3rem]'>
            {partnersArr?.map((partner:PartnerArr)=><div className='basis-[100%] md:basis-[48%] lg:basis-[23%] flex-1 shadow-[0px_4px_15px_5px_rgba(0,0,0,0.1)] text-center p-[20px] rounded-[20px]' key={partner?.id}>
            <div className='text-[#2B3379] font-bold text-[20px]'>{partner?.title}</div>
                <img className='m-[auto] mt-[15px]' src={partner?.icon} alt='partner logo'/>
                <p className='text-[16px] md:text-[18px] text-[#2B3379] mt-[15px]'>
                    {partner?.description}
                </p>
                <h4 className='font-semibold text-[#555555] text-[16px] mt-[15px]'>{partner?.subHeading}</h4>
            </div>)}
        </div>
    </div>
}

export default Partners